import { render, staticRenderFns } from "./EditSponsored.vue?vue&type=template&id=30282de8&scoped=true&"
import script from "./EditSponsored.vue?vue&type=script&lang=js&"
export * from "./EditSponsored.vue?vue&type=script&lang=js&"
import style0 from "./EditSponsored.vue?vue&type=style&index=0&id=30282de8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30282de8",
  null
  
)

export default component.exports